/** Server-advertised name for the browser-sandboxed bash tool. */
export const BASH_TOOL_NAME = "bash";
